import { FC } from 'react';
import {
  ActionsWrapper,
  ConfirmContent,
  ConfirmText,
  ConfirmWrapper,
  FilledButton,
  SecondText,
  TextBlock,
} from './styles';

export const TemplateModal: FC<{
  mainText: React.ReactNode;
  confirmText: string;
  secondText: string;
  cancelText: string;
  onConfirm: () => void;
  onSecond: () => void;
}> = ({
  mainText,
  confirmText,
  secondText,
  cancelText,
  onConfirm,
  onSecond,
}) => (
  <ConfirmWrapper>
    <ConfirmContent>
      <TextBlock>
        <ConfirmText>{mainText}</ConfirmText>
        {!!secondText && <SecondText>{secondText}</SecondText>}
      </TextBlock>

      {(!!cancelText || !!confirmText) && (
        <ActionsWrapper>
          {!!cancelText && (
            <FilledButton onClick={onSecond}>{cancelText}</FilledButton>
          )}
          {!!confirmText && !!onConfirm && (
            <FilledButton onClick={onConfirm}>{confirmText}</FilledButton>
          )}
        </ActionsWrapper>
      )}
    </ConfirmContent>
  </ConfirmWrapper>
);
import { FC } from 'react';
import {
  ActionsWrapper,
  ConfirmContent,
  ConfirmText,
  ConfirmWrapper,
  FilledButton,
  SecondText,
  TextBlock,
} from './styles';

export const TemplateModal: FC<{
  mainText: React.ReactNode;
  confirmText: string;
  secondText: string;
  cancelText: string;
  onConfirm: () => void;
  onSecond: () => void;
}> = ({
  mainText,
  confirmText,
  secondText,
  cancelText,
  onConfirm,
  onSecond,
}) => (
  <ConfirmWrapper>
    <ConfirmContent>
      <TextBlock>
        <ConfirmText>{mainText}</ConfirmText>
        {!!secondText && <SecondText>{secondText}</SecondText>}
      </TextBlock>

      {(!!cancelText || !!confirmText) && (
        <ActionsWrapper>
          {!!cancelText && (
            <FilledButton onClick={onSecond}>{cancelText}</FilledButton>
          )}
          {!!confirmText && !!onConfirm && (
            <FilledButton onClick={onConfirm}>{confirmText}</FilledButton>
          )}
        </ActionsWrapper>
      )}
    </ConfirmContent>
  </ConfirmWrapper>
);
